import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";
import { getBaseUrlParams } from "../../../../utils/getBaseUrlParams.js";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_MODULE_LOADING = "saga/SET_MODULE_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_PAGE_DATA";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_PAGE_DATA_SUCCESS";
export const FETCH_PREFERENCES_SUCCESS = "saga/FETCH_PREFERENCES_SUCCESS";
export const UPDATE_PREFERENCES_SUCCESS = "saga/UPDATE_PREFERENCES_SUCCESS";
export const UPDATE_PREFERENCES = "saga/UPDATE_PREFERENCES";
export const FETCH_CLIENT_INFO_SUCCESS = "saga/FETCH_CLIENT_INFO_SUCCESS";
export const FETCH_CLIENT_ATTENDANCE_SUCCESS = "saga/FETCH_CLIENT_ATTENDANCE_SUCCESS";
export const FETCH_CLIENT_SALES_SUCCESS = "saga/FETCH_CLIENT_SALES_SUCCESS";
export const FETCH_CLIENT_PAST_DUES_SUCCESS = "saga/FETCH_CLIENT_PAST_DUES_SUCCESS";
export const FETCH_CLIENT_MEMBERSHIP_TYPES_SUCCESS = "saga/FETCH_CLIENT_MEMBERSHIP_TYPES_SUCCESS";
export const FETCH_CLIENT_PROSPECT_TYPES_SUCCESS = "saga/FETCH_CLIENT_PROSPECT_TYPES_SUCCESS";
export const FETCH_CLIENT_CONTRACTS_SUCCESS = "saga/FETCH_CLIENT_CONTRACTS_SUCCESS";
export const FETCH_PIE_CHART_SUCCESS = "saga/FETCH_PIE_CHART_SUCCESS";
export const FETCH_CONTRACTS_STATUSES_SUCCESS = "saga/FETCH_CONTRACTS_STATUSES_SUCCESS";
export const FETCH_CONTRACTS_FREEZES_SUCCESS = "saga/FETCH_CONTRACTS_FREEZES_SUCCESS";
export const FETCH_CLIENT_CONTACT_LOGS_SUCCESS = "saga/FETCH_CLIENT_CONTACT_LOGS_SUCCESS";
export const FETCH_CLIENT_CHARTS_SUCCESS = "saga/FETCH_CLIENT_CHARTS_SUCCESS";
export const FETCH_CLIENT_CHECKINS_SUCCESS = "saga/FETCH_CLIENT_CHECKINS_SUCCESS";
export const FETCH_REMAINING_SESSIONS_SUCCESS = "saga/FETCH_REMAINING_SESSIONS_SUCCESS";
export const FETCH_DATA_ERROR = "saga/FETCH_DATA_ERROR";
export const SEND_CONTACT_LOG_REQUEST = "saga/SEND_CONTACT_LOG_REQUEST";
export const SEND_CONTACT_LOG_REQUEST_SUCCESS = "saga/SEND_CONTACT_LOG_REQUEST_SUCCESS";
export const SET_CLIENT_LOGS_LOADING = "sagas/SET_CLIENT_LOGS_LOADING";
export const SET_API_ERROR = "sagas/SET_API_ERROR";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  sendContactLogRequest: createAction(SEND_CONTACT_LOG_REQUEST),
  updatePreferences: createAction(UPDATE_PREFERENCES)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, fetchCurrentUser);
  yield takeLatest(UPDATE_PREFERENCES, updatePreferences);
}

const basePath = "pages/clients/";
const loadedModules = [];

const getUrlParams = () => {
  const url = window.location.href;
  const { searchParams } = new URL(url);

  return {
    short_url: searchParams.get("dashboard_short_url"),
    client_uid: searchParams.get("client_uid")
  };
};

const sagaMapping = {
  freezes: getClientData(`${basePath}/contracts/contract_freezes`, FETCH_CONTRACTS_FREEZES_SUCCESS),
  salesAndAttendanceData: getClientData(`${basePath}sales_and_attendance_chart`, FETCH_CLIENT_CHARTS_SUCCESS),
  contractsAgreements: getClientData(`${basePath}contracts`, FETCH_CLIENT_CONTRACTS_SUCCESS),
  contactLogs: getClientData(`${basePath}contact_logs`, FETCH_CLIENT_CONTACT_LOGS_SUCCESS),
  pastdues: getClientData(`${basePath}past_dues`, FETCH_CLIENT_PAST_DUES_SUCCESS),
  checkIns: getClientData(`${basePath}check_ins`, FETCH_CLIENT_CHECKINS_SUCCESS),
  pieCharts: getClientData(`${basePath}pie_charts`, FETCH_PIE_CHART_SUCCESS),
  bookings: getClientData(`${basePath}bookings`, FETCH_CLIENT_ATTENDANCE_SUCCESS),
  sales: getClientData(`${basePath}sales`, FETCH_CLIENT_SALES_SUCCESS),
  remainingSessions: getClientData(`${basePath}remaining_sessions`, FETCH_REMAINING_SESSIONS_SUCCESS),
  membershipTypes: getClientData(
    `${basePath}clients/membership_types`,
      FETCH_CLIENT_MEMBERSHIP_TYPES_SUCCESS
  ),
  membershipStatuses: getClientData(
    `${basePath}contracts/contract_statuses`,
    FETCH_CONTRACTS_STATUSES_SUCCESS
  ),
  prospectypes: getClientData(
    `${basePath}clients/prospect_types`,
    FETCH_CLIENT_PROSPECT_TYPES_SUCCESS
  )
};

function getClientData(endpoint, successActionType) {
  return function* () {
    const params = yield getCommonApiParams();
    try {
      const response = yield call(axios.get, queryParams.apiVersion + endpoint, { params });

      if (typeof response.data === "string") {
        yield put({ type: SET_API_ERROR, payload: true });
      }

      yield put({ type: successActionType, payload: response.data });
    } catch (error) {
      console.error(error);
      yield put({ type: FETCH_DATA_ERROR, payload: error });
    }
  };
}

export function* fetchCurrentUser() {
  const { short_url, client_uid } = yield getUrlParams();
  const { organization_id } = yield getBaseUrlParams();

  yield put({ type: SET_LOADING, payload: true });
  try {
    const {
      data: { preload_page }
    } = yield call(axios.get, queryParams.apiVersion + `settings/pages`, {
      params: {
        page: "ClientProfiles",
        short_url,
        client_uid,
        organization_id
      }
    });

    yield put({ type: FETCH_PREFERENCES_SUCCESS, payload: preload_page.preferences });
    yield put({
      type: FETCH_CURRENT_USER_SUCCESS,
      payload: { ...preload_page.commonProps, client_uid }
    });

    yield getClientInfo();
    yield put({ type: SET_LOADING, payload: false });

    yield fetchActiveModules();
  } catch (error) {
    console.error(error);
  }
}

function* fetchModule(module, sagaFunction) {
  if (sagaFunction) {
    yield sagaFunction();
    loadedModules.push(module.name);
  }
  yield put({ type: SET_MODULE_LOADING, payload: { [module.name]: false } });
}

function* loadModules(sagaMapping) {
  const preferences = yield select((state) => state.clientProfileModule.preferences);
  const allSagas = preferences
    .filter((module) => module.active && !loadedModules.includes(module.name))
    .map((module) => fetchModule(module, sagaMapping[module.name]));

  yield all(allSagas);
}

export function* fetchActiveModules() {
  try {
    yield* loadModules(sagaMapping);
  } catch (error) {
    console.log(error);
  }
}

export function* updatePreferences({ payload }) {
  const { short_url, organization_id } = yield getCommonApiParams();

  try {
    const { data } = yield call(axios.put, queryParams.apiVersion + "settings/pages", {
      page_modules: payload.map((pref) => pref.name),
      page: "ClientProfiles",
      organization_id: organization_id.toString(),
      short_url
    });
    yield put({ type: UPDATE_PREFERENCES_SUCCESS, payload: data.preferences });
    yield fetchActiveModules();
  } catch (error) {
    console.error(error);
  }
}

function* getClientInfo() {
  const params = yield getCommonApiParams();
  try {
    const response = yield call(axios.get, queryParams.apiVersion + "pages/clients/clients/info", {
      params
    });
    if (typeof response.data === "string") {
      yield put({ type: SET_API_ERROR, payload: true });
    }
    yield put({ type: FETCH_CLIENT_INFO_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_DATA_ERROR, payload: error });
  }
}

function* getCommonApiParams() {
  return yield select((state) => {
    const {
      currentUser: { organization_id, client_uid, userPageShortUrl }
    } = state.clientProfileModule;
    const newdate = new Date();
    const m = newdate.getMonth() + 1;
    const y = newdate.getFullYear();
    const d = newdate.getDate();
    const currentDate = y + "-" + m + "-" + d;

    return {
      organization_id: organization_id,
      short_url: userPageShortUrl,
      client_uid: client_uid,
      date: currentDate
    };
  });
}
